import { Button, Container, Text } from "@chakra-ui/react"
import { Link } from "@tanstack/react-router"

import { ImConfused } from "react-icons/im"


const NotFound = () => {
  return (
    <Container
      h="100vh"
      alignItems="stretch"
      justifyContent="center"
      textAlign="center"
      maxW="sm"
      centerContent
    >
      <ImConfused
        style={{
          fontSize: 150,
          alignSelf: "center",
        }}
      />
      <Text
        fontSize="8xl"
        color="main"
        fontWeight="bold"
      >
        404
      </Text>
      <Text fontSize="md">Hoppla!</Text>
      <Text fontSize="md">Seite nicht gefunden.</Text>
      <Button color="main" borderColor="main" variant="outline" mt={4} asChild>
        <Link to="/">Zurück</Link>
      </Button>
    </Container>
  )
}

export default NotFound
